const styles = (theme) => ({
	paperDatagrid: {
		width: "100%",
		overflowX: "auto",
		backgroundColor: theme.palette.background.paper,
		borderRadius: "16px",
	},
	titleDatagrid: {
		color: theme.palette.text.primary,
		fontWeight: 500,
		padding: "16px 20px",
		textAlign: "left",
	},
	datagrid: {
		display: "grid",
		height: "100%",
		maxHeight: "100%",
		"&.MuiDataGrid-root": { borderRadius: "16px", border: "none" },

		// Reduz tamanho da fonte nas células
		"& .MuiDataGrid-cell": {
			fontSize: "0.75rem", // ou 12px
			py: "2px", // padding vertical reduzido
			borderColor: "theme.palette.secondary.dark", // Cor do contorno das células
			height: "35px",
			// justifyContent: "center",
			alignItems: "center",
			display: "flex",
			borderTop: `1px solid ${
				theme.palette.mode === "dark"
					? theme.palette.secondary.light
					: theme.palette.secondary.dark
			} !important`,
		},

		// Reduz tamanho da fonte nos títulos das colunas
		"& .MuiDataGrid-columnHeader": {
			fontSize: "0.75rem",
			py: "2px", // reduz altura do cabeçalho também
			color:
				theme.palette.mode == "dark"
					? theme.palette.secondary.light
					: theme.palette.secondary.dark,
		},

		"& .MuiDataGrid-columnSeparator": {
			color: theme.palette.secondary.dark,
			cursor: "col-resize",
			visibility: "visible",
			height: "100%",
		},

		// Intercala o background das linhas
		"& .linha-par": {
			backgroundColor: "inherit",
		},
		"& .MuiDataGrid-row:hover": {
			backgroundColor: "inherit",
		},

		"& .linha-impar": {
			// Necessário para não ter diferenças em hoover
			backgroundColor:
				theme.palette.mode == "dark"
					? theme.palette.secondary.dark
					: theme.palette.secondary.lighter,
		},
		"& .linha-impar:hover": {
			// Necessário para não ter diferenças em hoover
			backgroundColor:
				theme.palette.mode == "dark"
					? theme.palette.secondary.dark
					: theme.palette.secondary.lighter,
		},

		// Remove foco visual
		"& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
			outline: "none !important",
		},

		"& .MuiDataGrid-selectedRowCount": {
			// Remove legenda de linha selecionada
			fontSize: "0px",
		},
		'&.MuiDataGrid-root .MuiDataGrid-container--top [role="row"], & .MuiDataGrid-root .MuiDataGrid-container--bottom [role="row"]':
			{
				backgroundColor: "background.paper",
			},

		"& .MuiDataGrid-cell": {
			py: 0.5, // padding vertical menor
			px: 1, // padding horizontal menor
			fontSize: "0.85rem",
			borderTop: `0.2px solid ${
				theme.palette.mode === "dark"
					? theme.palette.secondary.dark
					: theme.palette.secondary.lighter
			} !important`,
		},
		"& .MuiDataGrid-row": {
			minHeight: "28px !important",
			maxHeight: "28px !important",
		},
		"& .MuiDataGrid-columnHeaders": {
			minHeight: "35px !important",
			maxHeight: "35px !important",
		},
		"& .MuiDataGrid-columnHeaderTitle": {
			fontSize: "0.85rem",
		},
		//////Footer
		"& .MuiDataGrid-footerContainer": {
			fontSize: "0.75rem",
			py: "0px",
			px: "0px",
			borderTop: `1px solid ${theme.palette.secondary.dark}`,
			backgroundColor:
				theme.palette.mode === "dark"
					? "transparent"
					: theme.palette.white.main,
			minHeight: "20px",
			height: "20px",
			alignItems: "center",
			display: "flex",
			overflowX: "hidden",
			overflowY: "hidden",
			mb: 1.4,
		},
		"& .MuiTablePagination-root": {
			fontSize: "0.75rem",
			py: "0px",
			px: "0px",
			height: "20px",
			alignItems: "center",
			display: "flex",
			overflowX: "hidden",
			overflowY: "hidden",
			position: "absolute",
			right: "0",
			transform: "translateY(8px)",
			color:
				theme.palette.mode === "dark"
					? theme.palette.colors.purple.light
					: theme.palette.colors.black.medium,
		},
		/**
		 * Animações
		 */
		// Padrão
		"& .onGoing-row": {
			fontWeight: "600",
			animation: `${
				theme.palette.mode === "dark" ? "myEffectDark" : "myEffectLight"
			} 2.5s infinite`,
		},
		// Por severidade
		...(theme.palette.mode === "dark"
			? {
					"& .severity-5": {
						animation: "criticalEffectDark 2.5s infinite",
						fontWeight: "600",
					},
					"& .severity-4": {
						animation: "highEffectDark 2.5s infinite",
						fontWeight: "600",
					},
					"& .severity-3": {
						animation: "mediumEffectDark 2.5s infinite",
						fontWeight: "600",
					},
					"& .severity-2": {
						animation: "lowEffectDark 2.5s infinite",
						fontWeight: "600",
					},
					"& .severity-1": {
						animation: "infoEffectDark 2.5s infinite",
						fontWeight: "600",
					},
			  }
			: {
					"& .severity-5": {
						animation: "criticalEffectLight 2.5s infinite",
						fontWeight: "600",
					},
					"& .severity-4": {
						animation: "highEffectLight 2.5s infinite",
						fontWeight: "600",
					},
					"& .severity-3": {
						animation: "mediumEffectLight 2.5s infinite",
						fontWeight: "600",
					},
					"& .severity-2": {
						animation: "lowEffectLight 2.5s infinite",
						fontWeight: "600",
					},
					"& .severity-1": {
						animation: "infoEffectLight 2.5s infinite",
						fontWeight: "600",
					},
			  }),
		// Padrão
		"@keyframes myEffectDark": {
			"0%, 100%": { color: theme.palette.tertiary.main, fontWeight: "600" },
			"50%": { color: theme.palette.white.main, fontWeight: "600" },
		},
		"@keyframes myEffectLight": {
			"0%, 100%": { color: theme.palette.tertiary.main, fontWeight: "600" },
			"50%": { color: theme.palette.black.main, fontWeight: "600" },
		},
		// Keyframes para animações
		"@keyframes criticalEffectDark": {
			"0%, 100%": {
				color: theme.palette.chip.colorText.critical,
			},
			"50%": {
				color: theme.palette.white.main,
			},
		},
		"@keyframes criticalEffectLight": {
			"0%, 100%": {
				color: theme.palette.chip.colorText.critical,
			},
			"50%": {
				color: theme.palette.black.main,
			},
		},
		"@keyframes highEffectDark": {
			"0%, 100%": {
				color: theme.palette.chip.colorText.high,
			},
			"50%": {
				color: theme.palette.white.main,
			},
		},
		"@keyframes highEffectLight": {
			"0%, 100%": {
				color: theme.palette.chip.colorText.high,
			},
			"50%": {
				color: theme.palette.black.main,
			},
		},
		"@keyframes mediumEffectDark": {
			"0%, 100%": {
				color: theme.palette.chip.colorText.success,
			},
			"50%": {
				color: theme.palette.white.main,
			},
		},
		"@keyframes mediumEffectLight": {
			"0%, 100%": {
				color: theme.palette.chip.colorText.success,
			},
			"50%": {
				color: theme.palette.black.main,
			},
		},
		"@keyframes lowEffectDark": {
			"0%, 100%": {
				color: theme.palette.chip.colorText.medium,
			},
			"50%": {
				color: theme.palette.white.main,
			},
		},
		"@keyframes lowEffectLight": {
			"0%, 100%": {
				color: theme.palette.chip.colorText.medium,
			},
			"50%": {
				color: theme.palette.black.main,
			},
		},
		"@keyframes infoEffectDark": {
			"0%, 100%": {
				color: theme.palette.chip.colorText.default,
			},
			"50%": {
				color: theme.palette.white.main,
			},
		},
		"@keyframes infoEffectLight": {
			"0%, 100%": {
				color: theme.palette.chip.colorText.default,
			},
			"50%": {
				color: theme.palette.black.main,
			},
		},
	},
});

export default styles;
